import { connect } from 'react-redux';
import Actions from '../../actions';
import PaymentRedsysRedirectKo from '../../components/checkout-steps/payment-redsys-redirect-ko';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: state.placedOrder,
    locale: state.locale,
    stores: state.stores.stores,
    hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
    gracePeriod: state.cartState.gracePeriod,
});

const mapDispatchToProps = (dispatch) => ({
    addRedsysPaymentError: (error) => {
        dispatch(Actions.addRedsysPaymentError(error));
    },
});

const PaymentRedsysRedirectKoConnector = connect(mapStateToProps, mapDispatchToProps)(PaymentRedsysRedirectKo);

export default PaymentRedsysRedirectKoConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/payment-redsys-redirect-ko-connector.js
 **/